import { AuthService } from './../../services/auth.service';
import { Location } from '@angular/common';
import { ClientesPymesService } from './../../services/clientes-pymes.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import 'rxjs/Rx';
import { saveAs } from 'file-saver/FileSaver';

@Component({
  selector: 'app-laboral',
  templateUrl: './laboral.component.html',
  styleUrls: ['./laboral.component.css']
})
export class LaboralComponent implements OnInit {

  codcliente:number;
  anio:number;
  mes:string;
  idcategoria:number;
  categorias;
  documentosNominas;
  documentosSeguridadSocial;
  documentosContratos;
  documentosCertificados;
  documentosActuaciones;
  documentosOtros;
  documentosFacturas;
  tipodocnuevo;
  tiposdoc;
  documento={};
  
  constructor(private activatedRoute:ActivatedRoute, private clientesPymesService:ClientesPymesService,
              private location:Location, private auth:AuthService, private router:Router) {
    this.activatedRoute.queryParams
    .subscribe(params=>{
      this.codcliente=params["idC"];
      this.anio=params["a"];
      this.idcategoria=params["c"];
      this.tipodocnuevo=params["nuevo"];
      
      if(this.auth.esClientePymes() && this.codcliente && this.codcliente!=this.auth.usuarioActivo.CLcodigo){
        this.router.navigate(['/home']);
        return false;
      }

      if(this.codcliente && this.anio && !this.idcategoria){
        this.cargarCategorias(this.codcliente, this.anio);
      }

      if(this.idcategoria && !this.codcliente){
        this.cargarMes(this.idcategoria);
        this.cargarCategoriaActual(this.idcategoria);
        this.cargarDocumentos(this.idcategoria, 'NO');
        this.cargarDocumentos(this.idcategoria, 'SS');
        this.cargarDocumentos(this.idcategoria, 'CO');
        this.cargarDocumentos(this.idcategoria, 'CE');
        this.cargarDocumentos(this.idcategoria, 'AC');
        this.cargarDocumentos(this.idcategoria, 'OT');
        this.cargarDocumentos(this.idcategoria, 'FA');
      }
    });



  }

  ngOnInit() {
    
  }

  cargarCategorias(codcliente, anio){
    this.clientesPymesService.cargarCategoriasLaboral(codcliente, anio)
    .subscribe(resp=>{
      this.categorias=resp;
    });
  }
  
  cargarDocumentos(codpadre, codtipodoc){
    
    this.clientesPymesService.cargarDocumentos(codpadre, codtipodoc)
    .subscribe(resp=>{
      switch(codtipodoc){
        case 'NO':
          this.documentosNominas=resp;
        break;
        case 'SS':
          this.documentosSeguridadSocial=resp;
        break;
        case 'CO':
          this.documentosContratos=resp;
        break;
        case 'CE':
          this.documentosCertificados=resp;
        break;
        case 'AC':
          this.documentosActuaciones=resp;
        break;
        case 'OT':
          this.documentosOtros=resp;
        break;
        case 'FA':
          this.documentosFacturas=resp;
        break;
      }
      
    });
  }

  cargarMes(codCategoria){
    this.clientesPymesService.cargarMes(codCategoria)
    .subscribe(resp=>{
      this.mes=resp["DLcategoria"];
      this.anio=resp["DLanio"];
    });
  }

  cargarCategoriaActual(codCategoria){
    this.clientesPymesService.cargarCategoriaActual(codCategoria)
    .subscribe(resp=>{
      if(resp["err"]==true){
        this.router.navigate(["/home"]);
        return false;
      }
    });
  }

  volver(){
    this.location.back();
  }

  descargarDoc(ruta:string){
    
    let rutaspliteada=ruta.split("/");
    let nombrearchivo=rutaspliteada[rutaspliteada.length-1];
    
    //window.location.href='https://app.solucionlegal.es/API/index.php/auth/descargar';
    this.clientesPymesService.descargarDoc(ruta)
    .subscribe(data=>saveAs(data, nombrearchivo)),
    error=> console.log("Error downloading"),
    ()=>console.log("Nice.");
    //data=>window.open(window.URL.createObjectURL(data))
  }

  borrarDoc(codigoDoc, codtipodoc){
    if(confirm("¿Desea borrar el documento seleccionado?")){
      this.clientesPymesService.borrarDoc(codigoDoc)
      .subscribe(resp=>{
        this.cargarDocumentos(this.idcategoria, codtipodoc);
      });
    }
  }

  
}



// WEBPACK FOOTER //
// ./src/app/components/laboral/laboral.component.ts